import { createSelector } from '@reduxjs/toolkit';

export const selectTransactionCategory = (state) => state.transactionCategories.category;
export const selectData = (state) => state.transactionCategories.data;
export const selectError = (state) => state.transactionCategories.error;
export const selectLoading = (state) => Boolean(state.transactionCategories.loading);

export const selectTransactionCategoryOptions = createSelector([selectData], (data) => {
  return data?.map(({ category }) => ({ title: category, value: category }));
});
